import ChannelService from "@src/api/channeltalk";
import useUser from "@src/hook/useUser";
import { useEffect } from "react";
import TagManager from "react-gtm-module";
interface GlobalInitProps {
	authKey?: string;
}

const GlobalInit = ({ authKey }: GlobalInitProps) => {
	const { mutateGetUserData, user } = useUser();

	const onLoad = async () => {
		window.sessionStorage.setItem("accessToken", authKey || "");
		mutateGetUserData();
		TagManager.initialize({ gtmId: "GTM-KG654NL" });
		ChannelService.boot({
			pluginKey: process.env.NEXT_PUBLIC_CHANNEL_PLUGIN_KEY, //please fill with your plugin key
		});
	};

	useEffect(() => {
		onLoad();
	}, []);

	useEffect(() => {
		function checkUserData() {
			const accessToken =
				(typeof window !== "undefined" && window.sessionStorage.getItem("accessToken")) ||
				window.localStorage.getItem("accessToken");
			const refreshToken =
				typeof window !== "undefined" && window.localStorage.getItem("refreshToken");
			if (user.isLogin && !accessToken && !refreshToken) {
				window.location.href = "/";
			}
		}

		window.addEventListener("storage", checkUserData);

		return () => {
			window.removeEventListener("storage", checkUserData);
		};
	}, [user.isLogin]);

	return null;
};

export default GlobalInit;
